export function scheduleVersionId(aSelection){
  return aSelection ? (aSelection.value || aSelection.id) : null;
}

export function optionForScheduleVersion(aScheduleVersion, aTranslate, aDateFormatter, aUserFormatter){
  const publishedAt = aDateFormatter(aScheduleVersion.published_at || aScheduleVersion.created_at);
  const publishedBy = aUserFormatter(aScheduleVersion.published_by_user);
  const publishedByLabel = publishedBy ? ` - ${aTranslate('PUBLISHED_BY')} ${publishedBy}` : '';

  return {
    label:`${aTranslate('VERSION')} ${aScheduleVersion.version_number} - ${publishedAt}${publishedByLabel}`,
    value:aScheduleVersion.id,
    key:aScheduleVersion.id
  };
}
